export const links = [
  {
    key: "122",
    path: "home",
    name: "Home",
  },

  {
    key: "1232",
    path: "products",
    name: "products",
  },
  {
    key: "1212",
    path: "shops",
    name: "shops",
  },
  {
    key: "12412",
    path: "reviews",
    name: "reviews",
  },
  {
    key: "1532",
    path: "contact",
    name: "contact",
  },
];
